class QuizQuestions {
	/**
	 * QuizQuestions constructor
	 * @param {Array} questions
	 * @param {Number} currentStepIndex
	 */
	constructor(questions, currentStepIndex) {
		/** @type {QuizQuestion[]} */
		this._questions = this._buildAndGetQuizQuestions(questions);
		this._currentStepIndex = currentStepIndex;
	}

	/**
	 * @return {QuizQuestion|null}
	 */
	get currentQuestion() {
		const currentQuestion = this._questions[this._currentStepIndex];

		return currentQuestion ? currentQuestion : null;
	}

	get currentStepIndex() {
		return this._currentStepIndex;
	}

	get totalQuestions() {
		return this._questions.length;
	}

	get isLastQuestion() {
		return (this._currentStepIndex + 1) >= this.totalQuestions;
	}

	/**
	 * Builds and returns array of QuizQuestion.
	 * @param {Array} questions
	 * @return {QuizQuestion[]}
	 * @private
	 */
	_buildAndGetQuizQuestions(questions) {
		const quizQuestions = [];

		for (const question of questions) {
			quizQuestions.push(new QuizQuestion(question));
		}

		return quizQuestions;
	}

	next(answerKey) {
		let quizUiInstance = QuizUI.getInstance(),
			self = this;

		if (this.currentQuestion) {
			this.currentQuestion.selectedAnswer = answerKey;
		}

		if (this.isLastQuestion) {
			++this._currentStepIndex;

			if (quizUiInstance.isLoaderEnabled()) {
				quizUiInstance.showLoader();

				setTimeout(() => {
					$(document).trigger('quiz-last-question', {selectedAnswers: self._getSelectedAnswers()});
				}, 2000);
			} else {
				$(document).trigger('quiz-last-question', {selectedAnswers: self._getSelectedAnswers()});
			}
		} else {
			++this._currentStepIndex;
			quizUiInstance.updateQuestionData(this.currentQuestion, this.totalQuestions);
			quizUiInstance.hideLoader();
		}

		this.updateCurrentStepIndex();
	}

	prev() {
		if (this._currentStepIndex > 0) {
			--this._currentStepIndex;
			QuizUI.getInstance().updateQuestionData(this.currentQuestion, this.totalQuestions);
		}

		this.updateCurrentStepIndex();
	}

	updateCurrentStepIndex() {
		QuizUI.getInstance().$quiz.get(0).dataset.currentStepIndex = this._currentStepIndex;
	}

	current() {
		return this._questions[this._currentStepIndex];
	}

	_getSelectedAnswers() {
		const selectedAnswers = {};

		for (const question of this._questions) {
			selectedAnswers[question.key] = question.selectedAnswer;
		}

		return selectedAnswers;
	}
}
